import eure from './eure.svg'
import gno from './gno.svg'
import gnosis from './gnosis.svg'
import sdai from './sdai.svg'
import usdc from './usdc.svg'
import usdt from './usdt.svg'
import weth from './weth.svg'
import wsteth from './wsteth.svg'
import wxdai from './wxdai.svg'
import xdai from './xdai.svg'

export const tokenLogos = {
  xdai,
  wxdai,
  sdai,
  weth,
  wsteth,
  gno,
  usdc,
  'usdc.e': usdc,
  usdt,
  eure,
}

export const chainLogo = gnosis
